
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'ProductSlideShow',
  components: { VueSlickCarousel },
  // eslint-disable-next-line vue/require-prop-types
  props: ['listSlide'],
  data() {
    return {
      slideSetting: {
        'dots': false,
        'focusOnSelect': true,
        'infinite': true,
        'speed': 500,
        'slidesToShow': 4.8,
        'touchThreshold': 5
      }
    }
  }
}
